// App.js
import React from 'react';
import PrimeGenesis from './components/PrimeGenesis';

function App() {
    return (
        <div>
            <PrimeGenesis />
        </div>
    );
}

export default App;
